import * as React from 'react';
import {IonToolbar, IonItem, IonLabel, IonToggle, IonButton} from "@ionic/react";
import SkeletonText from "../../../components/common/SkeleltonText";
import {Ages} from "../../../utils/ages";
import {Facility, Employee, LessonType} from "../../../models";

interface FiltersToolbarProps {
    filterBookedOnly: boolean;
    facilities?: Facility[];
    filterFacility?: number;
    employees?: Employee[];
    filterEmployee?: number;
    slotTypes?: LessonType[];
    filterSlotType?: number;
    filterAvailableOnly: boolean;
    setFilterAvailableOnly: (availableOnly: boolean) => void;
    onSlotFilterOpenClick: () => void;
    isFiltered: boolean;
    setFilterFacility: (id?: number) => void;
    setFilterSlotType: (id?: number) => void;
    setFilterEmployee: (id?: number) => void;
    setFilterBookedOnly: (bookedOnly: boolean) => void;
    isRefreshing: boolean;
    selectedDate: number;
}

export const FiltersToolbar: React.FC<FiltersToolbarProps> = React.memo(({
    filterBookedOnly,
    facilities,
    filterFacility,
    employees,
    filterEmployee,
    slotTypes,
    filterSlotType,
    filterAvailableOnly,
    setFilterAvailableOnly,
    onSlotFilterOpenClick,
    isFiltered,
    setFilterFacility,
    setFilterSlotType,
    setFilterEmployee,
    setFilterBookedOnly,
    isRefreshing,
    selectedDate
}) => (
    <IonToolbar className="filters-toolbar ion-margin-bottom">
        { !filterBookedOnly &&
            (facilities?.length === 1 && !filterFacility)
            && (employees?.length === 1 && !filterEmployee)
            && (slotTypes?.length === 1 && !filterSlotType) &&
            <IonItem slot="start" lines="none">
                <IonLabel>
                    <IonToggle onIonChange={event => setFilterAvailableOnly(event.detail.checked)} checked={filterAvailableOnly}>Available</IonToggle>
                </IonLabel>
            </IonItem>
        }
        {
            (filterBookedOnly ||
                ((facilities && facilities?.length > 1) || filterFacility)
            || ((employees && employees?.length > 1) || filterEmployee)
            || ((slotTypes && slotTypes?.length > 1) || filterSlotType)) &&
            <IonItem slot="start" lines="none">
                <IonButton onClick={onSlotFilterOpenClick} color={"primary"} >
                    {!isFiltered && "Filters"}
                    {isFiltered && "Filtered"}
                </IonButton>

                { isFiltered &&
                    <IonButton onClick={() => {
                        setFilterFacility(undefined);
                        setFilterSlotType(undefined);
                        setFilterEmployee(undefined);
                        setFilterBookedOnly(false);
                        setFilterAvailableOnly(false);
                    }} color={"light"}>Clear</IonButton>
                }
            </IonItem>

        }
        <IonItem  className="ion-text-right" lines="none" slot="end" >
            <IonLabel style={{paddingTop: "9px", paddingBottom: "4px", textWrap: "nowrap"}}>
                {!isRefreshing && selectedDate && selectedDate > 0 && new Ages(selectedDate).toFormat("dd mmm yyyy")}
                {isRefreshing && <SkeletonText style={{display: "inline-block", width: "90px", height: "20px", marginTop: "-5px" }} />}
            </IonLabel>
        </IonItem>
    </IonToolbar>
));
